import { asyncType } from "redux/types/asyncTypes";

export const FETCH_AFF_PAYOUTS_OVER = asyncType("FETCH_AFF_PAYOUTS_OVER");
export const FETCH_AFF_PAYOUTS_HIST = asyncType("FETCH_AFF_PAYOUTS_HIST");
